<template>
    <div>
        <div v-show="step === 1" id="seat">
            <div class="title-booking">1 - CHỌN CHỖ</div>
            <seat-map v-model="form.seats"
                      :seats_available="seats_available"
                      :ticket_price_common="ticket_price_common"
                      @totalPrice="total_price = $event"
                      :v="$v.form.seats">

            </seat-map>
            <seat-preview class="mt-3" :seats="form.seats" :price="total_price"></seat-preview>
            <div class="row mt-3">
                <div class="col-6">
                </div>
                <div class="col-6">
                    <button name="next" type="button" class="btn btn-next" @click.stop="next">
                        Tiếp tục
                    </button>
                </div>
            </div>
        </div>
        <div v-show="step === 2" id="place">
            <div class="title-booking">2 - CHỌN ĐIỂM ĐÓN/ĐIỂM TRẢ</div>
            <place-detail v-model="form.places" :v="$v.form.places"></place-detail>
            <place-preview class="mt-3" :places="$v.form.places"></place-preview>
            <div class="row mt-3">
                <div class="col-6">
                    <button name="prev" type="button" class="btn btn-prev" @click.prevent="prev">
                        Quay lại
                    </button>
                </div>
                <div class="col-6">
                    <button name="next" type="button" class="btn btn-next" @click.stop="next">
                        Tiếp tục
                    </button>
                </div>
            </div>
        </div>
        <div v-show="step === 3" id="info">
            <div class="title-booking">3 - THÔNG TIN KHÁCH HÀNG</div>
            <customer-info v-model="form.customer" :v="$v.form.customer"></customer-info>
            <div class="row mt-3">
                <div class="col-6">
                    <button name="prev" type="button" class="btn btn-prev" @click.prevent="prev">
                        Quay lại
                    </button>
                </div>
                <div class="col-6">
                    <button name="next" type="button" class="btn btn-next" @click.stop="save">
                        Tiếp tục
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { SeatMap, PlaceDetail, CustomerInfo, SeatPreview, PlacePreview } from "../shared/components";
    import {minLength, required, minValue} from "vuelidate/lib/validators";
    import {RepositoryFactory, MixinHelper, eventBus, EVENTS } from "../../shared/services";
    import addMinutes from 'date-fns/addMinutes';
    import {HCROUTES} from "../../shared/constants/Constant";

    const repo = RepositoryFactory.get('schedules');
    export default {
        name: "BookingDetailMobile",
        mixins: [MixinHelper],
        components: {PlacePreview, SeatPreview, CustomerInfo, PlaceDetail, SeatMap},
        props: {
            schedule: {
                type: Object,
                required: true
            },
            query_params: {
                type: Object,
                required: true
            },

        },
        created() {
            this.schedule_id = this.getProp(this.schedule, 'id', null);
            repo.single(this.schedule_id, this.query_params)
                .then(res => {
                    this.ticket_price_common = this.getProp(res, 'data.data.common_ticket.price', 0);
                    this.seats_available = this.getProp(res, 'data.data.seats', []);
                })
                .catch(err => console.log(err));
            eventBus.$on(EVENTS.add_pickup_location, this.addPickupLocation);
            eventBus.$on(EVENTS.remove_pickup_location, this.removePickupLocation);
            eventBus.$on(EVENTS.add_getOff_location, this.addGetOffLocation);
            eventBus.$on(EVENTS.remove_getOff_location, this.removeGetOffLocation);
        },
        data() {
            return {
                schedule_id: null,
                step: 1,
                seats_available: [],
                ticket_price_common: 0,
                total_price: 0,
                form: {
                    seats: [],
                    places: {
                        pickupLocations: [{distance_library_id: 0, address: '', people_quantity: 1}],
                        getOffLocations: [{address: ''}]
                    },
                    customer: {
                        name: '',
                        phone_number: '',
                        note: ''
                    }
                }
            }
        },
        validations: {
            form: {
                seats: {
                    required,
                    minLength: minLength(1),
                },
                places: {
                    pickupLocations: {
                        required,
                        minLength: minLength(1),
                        $each: {
                            distance_library_id: {},
                            address: {
                                required
                            },
                            people_quantity: {
                                minValue: minValue(1),
                                required
                            }
                        }
                    },
                    getOffLocations: {
                        required,
                        minLength: minLength(1),
                        $each: {
                            address: {
                                required
                            }
                        }
                    }
                },
                customer: {
                    name: {
                        required,
                        minLength: minLength(4)
                    },
                    phone_number: {
                        required
                    },
                    note: {}
                }
            }
        },
        methods: {
            prev() {
                this.step--;
            },
            next() {
                if (!this.isValid(this.step)) {
                    return;
                }
                this.step++;
            },
            save() {
                this.$v.form.$touch();
                if (this.$v.form.$pending || this.$v.form.$error) {
                    return;
                }
                if (!this.$store.getters.isAuthenticated) {
                    this.$modalAuth.show();
                    return;
                }
                // const formData = {...this.form, schedule_id: this.schedule_id, query_params: this.query_params};
                // repoOrder.create(this.buildDataCreateOrder(formData))
                //     .then(resp => {
                //         const order_id = this.getProp(resp, 'data.data.id', 0);
                //         this.$router.push({name: 'payments', params: {order_id}});
                //     })
                //     .catch(err => console.log(err))
                const dataTransfer = {
                    totalPrice: this.total_price,
                    formData: this.buildDataCreateOrder({...this.form, schedule_id: this.schedule_id, query_params: this.query_params}),
                    seats_preview: this.form.seats,
                    schedule: this.schedule,
                    expire: addMinutes(new Date(), 15).valueOf()
                };
                this.removeData('order_id');
                this.storeData('data_order', dataTransfer);
                this.$router.push({name: HCROUTES.payment});
            },
            isValid(step) {
                if (step === 1) {
                    return this.validateStepFirst();
                } else if (step === 2) {
                    return this.validateStepSecond();
                } else if (step === 3) {
                    return this.validateStepThree();
                }
            },
            validateStepFirst() {
                let valid = true;
                this.$v.form.seats.$touch();
                if (this.$v.form.seats.$pending || this.$v.form.seats.$error) {
                    this.$modalNotify.show({
                        content: 'Vui lòng chọn ít nhất một chỗ ngồi'
                    });
                    valid = false;
                }
                return valid;
            },
            validateStepSecond() {
                this.$v.form.places.$touch();
                if (this.$v.form.places.$pending || this.$v.form.places.$error) {
                    this.$modalNotify.show({
                        content: 'Vui lòng chọn điểm đi, điểm đón'
                    });
                    return false;
                }

                if (!this.isPeopleQuantityPickupEqualsSeatQuantity(this.form)) {
                    this.$modalNotify.show({
                        content: 'Số lượng người đón phải bằng số lượng ghế đã đặt'
                    });
                    return false;
                }

                return true;
            },
            validateStepThree() {
                let valid = true;
                this.$v.form.customer.$touch();
                if (this.$v.form.customer.$pending || this.$v.form.customer.$error) {
                    valid = false;
                }
                return valid;
            },
            addPickupLocation() {
                this.form.places.pickupLocations.push({distance_library_id: 0, address: '', people_quantity: 1});
            },
            removePickupLocation(index) {
                this.form.places.pickupLocations.splice(index, 1);
            },
            addGetOffLocation() {
                this.form.places.getOffLocations.push({address: ''});
            },
            removeGetOffLocation(index) {
                this.form.places.getOffLocations.splice(index, 1);
            }
        },
        beforeDestroy() {
            eventBus.$off(EVENTS.add_pickup_location);
            eventBus.$off(EVENTS.remove_pickup_location);
            eventBus.$off(EVENTS.add_getOff_location);
            eventBus.$off(EVENTS.remove_getOff_location);
        }
    }
</script>

<style scoped>

    .nav-tabs li {
        float: left;
        margin-bottom: -1px;
        width: 33%;
        text-align: center;
        text-transform: uppercase;
        font-weight: 700;
        border-radius: 5px 5px 0 0;
    }

    .nav > li > a {
        padding: 10px 15px;
        color: #8C8C8C;
        width: 100%;
        display: block;
        position: relative;
    }

    .title-booking {
        background: #2461aa;
        font-weight: 700;
        line-height: 45px;
        padding-left: 15px;
        padding-right: 15px;
        color: #fff;
        margin-bottom: 10px;
    }

    .btn-prev {
        background: #b3b3b3;
        width: 100%;
        color: #e9e9e9;
    }

    .btn-next {
        background: #177bd0;
        width: 100%;
        color: #e9e9e9;
    }
</style>
